class OkendoReviewAggregate extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.getOkendoAggregate = this.getOkendoAggregate.bind(this)

    this.getOkendoAggregate(this.dataset.product)
  }

  getOkendoAggregate (productId) {
    fetch(
      `https://api.okendo.io/v1/stores/2d1c9a26-7bfe-4c39-a85e-b38925147073/products/shopify-${productId}/review_aggregate`,
    )
      .then((response) => response.json())
      .then((data) => {
        const reviewStar = `
            <div class="prd-Media_ReviewTrustStar">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11 11">
                <g clip-path="url(#a)">
                  <path fill="#272727" d="m3.994 3.476.998-2.37a.5.5 0 0 1 .913-.02l1.14 2.409a.5.5 0 0 0 .4.283l2.304.243a.5.5 0 0 1 .289.862L8.143 6.652a.5.5 0 0 0-.149.463l.5 2.498a.5.5 0 0 1-.744.53L5.68 8.923a.5.5 0 0 0-.508 0l-2.07 1.218a.5.5 0 0 1-.744-.529l.502-2.509a.5.5 0 0 0-.137-.451L.947 4.876a.5.5 0 0 1 .301-.85l2.338-.246a.5.5 0 0 0 .408-.304Z"/>
                </g>

                <defs>
                  <clipPath id="a"><path fill="#fff" d="M0 0h11v11H0z"/></clipPath>
                </defs>
              </svg>
            </div>
          `

        if (
          data.reviewAggregate != null &&
          data.reviewAggregate.ratingAndReviewCount > 0
        ) {
          const reviewRating = (
            data.reviewAggregate.reviewRatingValuesTotal /
            data.reviewAggregate.reviewCount
          ).toFixed(1)
          const reviewCount = data.reviewAggregate.reviewCount
          const reviewText = this.dataset.text
          const reviewTrustBadge = `
            <div class="prd-Media_ReviewTrustBadge">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path fill="#579BE0" d="M8.501 3.115c.36-1.593 2.63-1.593 2.99 0a1.533 1.533 0 0 0 2.314.958c1.381-.872 2.986.733 2.114 2.115a1.533 1.533 0 0 0 .958 2.313c1.594.36 1.594 2.63 0 2.99a1.533 1.533 0 0 0-.958 2.314c.872 1.381-.733 2.986-2.114 2.114a1.533 1.533 0 0 0-2.314.958c-.36 1.594-2.63 1.594-2.99 0a1.533 1.533 0 0 0-2.313-.958c-1.382.872-2.987-.733-2.115-2.114a1.533 1.533 0 0 0-.958-2.314c-1.593-.36-1.593-2.63 0-2.99a1.533 1.533 0 0 0 .958-2.313c-.872-1.381.733-2.987 2.115-2.115.895.566 2.08.075 2.313-.958Z"/><path fill="#FBFAF8" d="m8.968 12.696-2.571-2.593.726-.733 1.845 1.86 3.9-3.934.729.734-4.629 4.666Z"/>
              </svg>
            </div>
          `

          this.innerHTML = `${reviewRating} ${reviewStar} (${reviewCount}) ${reviewText} ${reviewTrustBadge}`

          this.setAttribute('aria-busy', false)
          this.setAttribute('aria-hidden', false)
        }
      })
  }
}

if (!customElements.get('okendo-review-aggregate')) {
  customElements.define('okendo-review-aggregate', OkendoReviewAggregate)
}
